<div mat-dialog-content>
    <div class="head-exam-type-modal-list">
        <h2>Selecione o Favorito (Externa)</h2>
    </div>

    <form class="form" [formGroup]="model">
        <div class="mat-dialog-content" style="padding-top: 15px;">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <mat-form-field appearance="outline">
                        <mat-label>Favorito</mat-label>
                        <mat-select formControlName="idMedicFavoriteExternalPrescription" (selectionChange)="loadPrescription($event)">
                            <mat-option [value]="0">Selecione...</mat-option>
                            <mat-option *ngFor="let item of listMedicFavoritePrescription" [value]="item.idMedicFavoriteExternalPrescription">
                                {{item.favoritePrescriptionName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            
            <app-loading-list *ngIf="loading"></app-loading-list>

            <div class="footer-panel-modal-list">
                <div class="row">
                    <div class="col-6">
                        <a mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</a>
                    </div>
                    <div class="col-6">
                        <button mat-flat-button type="button" color="primary" class="btn-block" [disabled]="!selected" (click)="clickAdd()">
                            Adicionar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>